import merge from 'lodash/merge';
import {twMerge} from '../../../common/twMerge';
import {MOBILE_HEADER_HEIGHT_PX} from '../../../header/constants';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {MobileCommentHeaderProps} from './MobileCommentHeaderProps.interface';

export function MobileCommentHeader({
  title,
  onClickContentHome,
  onClickBack,
  className,
  style,
  ...props
}: MobileCommentHeaderProps) {
  return (
    <div
      className={twMerge(
        'flex w-full items-center justify-between bg-theme-bg-base px-18pxr',
        className
      )}
      style={merge(
        {
          height: MOBILE_HEADER_HEIGHT_PX,
        },
        style
      )}
      {...props}
    >
      <div className="shrink-0">
        <Icon type={IconType.NavigationBack} onClick={onClickBack} />
      </div>
      <div className="flex flex-1 items-center justify-center">
        <Text className="font-medium2-bold text-theme-solid-100">{title}</Text>
      </div>
      <div className="shrink-0">
        <Icon
          type={IconType.NavigationContentsHome}
          onClick={onClickContentHome}
        />
      </div>
    </div>
  );
}
